import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { get_all_emp_tasks, release_task, watch_task } from './api';

const initialState = {
  loading: false,
  user: null
};

const actions = {
  GET_ALL_EMP_TASKS: 'plans/GET_ALL_EMP_TASKS',
  UPDATE_RELEASE_TASK: 'plans/UPDATE_RELEASE_TASK',
  WATCH_TASK: 'plans/WATCH_TASK'
};

export const getAllEmptasks = createAsyncThunk(
  actions.GET_MY_TASKS,
  async (payload) => {
    const response = await get_all_emp_tasks('my_reviews', payload);
    // console.log(response);
    return response;
  }
);

export const updateRelease = createAsyncThunk(
  actions.UPDATE_RELEASE_TASK,
  async (payload) => {
    const response = await release_task('release_task', payload);

    return response;
  }
);

export const watchTask = createAsyncThunk(
  actions.WATCH_TASK,
  async (payload) => {
    const response = await watch_task('watch-task', payload);
    return response;
  }
);

export const reviewSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllEmptasks.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllEmptasks.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg } = action.payload;
        if (!success) {
          message.error(msg);
        }
      })
      .addCase(getAllEmptasks.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(updateRelease.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateRelease.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(updateRelease.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
    builder
      .addCase(watchTask.pending, (state) => {
        state.loading = true;
      })
      .addCase(watchTask.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(watchTask.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });
  }
});

export const selectReviewSlice = (state) => {
  return state.reviews;
};

export default reviewSlice.reducer;
